export const responsibleOptions = [
  "Benchtop",
  "Building",
  "CNC",
  "Chassis",
  "Chassis Prep",
  "Cleaning",
  "Damaged",
  "Decal",
  "Doors & Drawers",
  "Electrical",
  "Finishing",
  "Floor",
  "Furniture",
  "J-Mould",
  "Planning",
  "Plumbing",
  "Roof Prep",
  "Sealing",
  "Splashback",
  "Stock",
  "Supplier",
  "Wall Prep",
];
